import { render, staticRenderFns } from "./BulkMarkAsAnsweredModal.vue?vue&type=template&id=75f4ba76&scoped=true"
import script from "./BulkMarkAsAnsweredModal.vue?vue&type=script&lang=js"
export * from "./BulkMarkAsAnsweredModal.vue?vue&type=script&lang=js"
import style0 from "./BulkMarkAsAnsweredModal.vue?vue&type=style&index=0&id=75f4ba76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f4ba76",
  null
  
)

export default component.exports